export default {
    defaultProps: {
        variant: "contained",
    },
    styleOverrides: {
        root: {
            display: "flex",
            justifyContent: "flex-end",
            boxShadow: "none",
        },
    },
};
